import { Controller } from "@hotwired/stimulus"

export class DebouncedFormSubmitter {
  constructor(form, {
    delay = 250,
    setTimer = (...args) => globalThis.setTimeout(...args),
    clearTimer = (...args) => globalThis.clearTimeout(...args)
  } = {}) {
    this.form = form
    this.delay = delay
    this.setTimer = setTimer
    this.clearTimer = clearTimer
    this.timer = null
  }

  schedule() {
    this.cancel()
    this.timer = this.setTimer(() => {
      this.timer = null
      this.form.requestSubmit()
    }, this.delay)
  }

  cancel() {
    if (this.timer === null) return

    this.clearTimer(this.timer)
    this.timer = null
  }
}

export default class extends Controller {
  static values = { delay: { type: Number, default: 250 } }

  connect() {
    this.submitter = new DebouncedFormSubmitter(this.element, { delay: this.delayValue })
  }

  disconnect() {
    this.cancel()
  }

  search() {
    this.submitter.schedule()
  }

  cancel() {
    this.submitter?.cancel()
  }
}
